<template>
	<transition name="fade">
		<div>
			<div slot="no-body" class="tabs-container">
				<div class="tab-text">
					<upload-file-form-optimization
						v-if="showUploadFileOptimization"
						ref="UploadFileFormOptimization"
						:inputFileId="inputFileId"
						:inputFileIcon="inputFileIcon"
						:typeUploadFile="typeUploadFile"
						:activateListUploadFile="activateListUploadFile"
						:typeAction="typeAction"
						@uploadStatusEmit="uploadStatusEmit"
						@dataFileEmit="getDataFile"
						@closePopupUploadFileEmit="closePopupUploadFile"
					/>
					<set-equivalences
						v-else-if="showSetEquivalenceOptimization"
						ref="SetEquivalences"
						:typeUploadFile="typeUploadFile"
						:activateListUploadFile="activateListUploadFile"
						:typeServiceVisitPoint="typeService"
						@closeEquivalenceEmit="closeEquivalenceEmit"
						@cancelEquivalenceEmit="cancelEquivalenceEmit"
						@disableNextButton="handleDisableNextButton"
						@jobUploadCompleteEmit="closePopupUploadFile"
					></set-equivalences>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import SetEquivalences from "@/components/optimization/upload-file/SetEquivalences.vue";
import UploadFileFormOptimization from "@/components/optimization/upload-file/UploadFileFormOptimization.vue";

export default {
	components: {
		SetEquivalences,
		UploadFileFormOptimization,
	},
	props: {
		typeUploadFile: {
			type: String,
			default: "VEHICLE_UPLOAD",
		},
		activateListUploadFile: {
			type: Boolean,
			default: true,
		},
		typeService: {
			type: String,
			default: "PICKUP",
		},
		inputFileId: {
			type: String,
			default: "fileOptimization",
		},
		inputFileIcon: {
			type: String,
			default: "TruckIcon",
		},
		showUploadFileOptimization: {
			type: Boolean,
			default: true,
		},
		showSetEquivalenceOptimization: {
			type: Boolean,
			default: false,
		},
		typeAction: {
			type: String,
			default: "UPLOAD",
		},
	},
	methods: {
		selectedUploadFileEmit(object) {
			this.uploadFile = object;
		},
		uploadStatusEmit(val) {
			if (val) {
				this.$emit("setUploadFileOptimization", false);
				this.$emit("setEquivalenceOptimization", true);
			}
		},
		closeEquivalenceEmit() {
			this.cancelEquivalenceEmit();
			if (this.typeAction === "UPDATE") this.$emit("closePopupEmit");
		},
		cancelEquivalenceEmit() {
			this.$emit("setUploadFileOptimization", true);
			this.$emit("setEquivalenceOptimization", false);
		},
		cleanData() {
			this.$refs.UploadFileFormOptimization.cleanData();
		},
		getDataFile(val) {
			this.$emit("dataFileEmit", val);
		},
		closePopupUploadFile() {
			this.$emit("closePopupEmit");
		},
		handleDisableNextButton(disabled) {
			this.$emit("disableNextButton", disabled);
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.fade-enter-active {
	transition: opacity 0.7s;
}
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
